import React from "react";
import { Box, ListItem, ListItemIcon, ListItemText, Typography } from "@mui/material";
import DoneIcon from "@mui/icons-material/Done";

const ConvoMatch = (props) => {
  const { response } = props;

  const match = response.Answer.matches[0];
  const meaning = match.meaning;
  const score = match.is_exact ? "exact" : [match.scores[0].slice(0, 4)];
  const speech = match.character_speech;
  const userSpeech = match.user_speech;
  const discoveries = Array.isArray(match.discoveries) ? match.discoveries.join(", ") : "";
  const opportunities = Array.isArray(match.opportunities) ? match.opportunities.join(", ") : "";

  return (
    <ListItem alignItems="flex-start" sx={{ borderBottom: "1px solid", borderColor: "divider" }}>
      <ListItemIcon sx={{ minWidth: 36, mt: 1 }}>
        <DoneIcon color="success" fontSize="small" />
      </ListItemIcon>
      <ListItemText
        disableTypography
        primary={
          <Box>
            <Typography variant="body2">
              <strong>User:</strong> {userSpeech}
            </Typography>
            <Typography variant="body2">
              <strong>Character:</strong> {speech}
            </Typography>
          </Box>
        }
        secondary={
          <Box sx={{ mt: 0.5, color: "text.secondary" }}>
            <Typography variant="caption" component="div">
              Score: {score}
            </Typography>
            <Typography variant="caption" component="div">
              Meaning: {meaning}
            </Typography>
            <Typography variant="caption" component="div">
              Discoveries: {discoveries}
            </Typography>
            <Typography variant="caption" component="div">
              Opportunity Ids: {opportunities}
            </Typography>
          </Box>
        }
      />
    </ListItem>
  );
};

export default ConvoMatch;
